import axios, { AxiosError } from 'axios'

import { httpClient } from 'shared/lib'
import consoleMessage from 'shared/utils/helpers/consoleMessage'

import { AddServicePayload, AdditionalServicesResponseType } from './types'

export function fetchServices(locationUuid?: string) {
   let errMessage = ''

   return httpClient
      .get<AdditionalServicesResponseType>(`additional-services/${locationUuid}`)
      .then((res) => {
         if (res.data) {
            return res.data
         }
         throw new Error('No data in request')
      })
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (axios.isAxiosError(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('ADDITIONAL SERVICES fetchServices()', errMessage, 'error')
         throw error
      })
}

export function addService(payload: AddServicePayload, locationUuid: string) {
   let errMessage = ''

   return httpClient
      .post(`additional-services/${locationUuid}`, payload)
      .then((res) => ({
         status: res.status,
      }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (axios.isAxiosError(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('ADDITIONAL SERVICES addService()', errMessage, 'error')
         throw error
      })
}

export function editService(payload: AddServicePayload, locationUuid: string, serviceUuid: string) {
   let errMessage = ''

   return httpClient
      .put(`additional-services/${locationUuid}/${serviceUuid}`, payload)
      .then((res) => ({
         status: res.status,
      }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (axios.isAxiosError(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('ADDITIONAL SERVICES addService()', errMessage, 'error')
         throw error
      })
}

export function deleteService(locationUuid: string, serviceUuid: string) {
   let errMessage = ''

   return httpClient
      .delete(`additional-services/${locationUuid}/${serviceUuid}`)
      .then((res) => ({
         status: res.status,
      }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (axios.isAxiosError(error)) {
            errMessage = error.response?.data?.errors[0].code || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('ADDITIONAL SERVICES addService()', errMessage, 'error')
         throw error
      })
}
